import fillWithZeros from '../helpers/fillWithZeros';
import { isNullOrUndefined } from '../helpers/utils';

/**
 * Formats a Date instance to brazilian format, DD/MM/YYYY.
 * @example ```js
 * formatToDate(new Date(2002, 7, 21))
 * //=> '21/08/2002'
 *
 * formatToDate(new Date())
 * //=> '08/09/2018'
 * ```
 * @param value - A Date instance.
 */
const formatToDate = function (value: Date | number): string {
	if (isNullOrUndefined(value) || value === 0 || (value instanceof Date && value.getTime() === 0)) {
		return '';
	}
	const data: Date = (value instanceof Date ? value : new Date(value));
	return `${fillWithZeros(data.getDate(), 2)}/${fillWithZeros(data.getMonth() + 1, 2)}/${fillWithZeros(data.getFullYear(), 4)}`;
};

export default formatToDate;
